import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL1 } from "../utils/apiURL";
import { selectUser } from "../store/authSlice"; // Assure-toi d'importer le sélecteur d'utilisateur

const initialState = {
  order: null,
  loading: false,
  error: null,
  orderProducts: [], // Nouveau champ pour stocker les produits de la commande
  status: null, // Ajouter le statut
  total: null, // Ajouter le total
  orders: [] // Liste des commandes
};

const getAuthHeaders = (state) => {
  const user = selectUser(state);
  const token = localStorage.getItem("token");

  if (!user || !token) {
    throw new Error("User is not authenticated");
  }

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

// Action asynchrone pour passer une commande
export const placeOrderAsync = createAsyncThunk(
  "order/placeOrderAsync",
  async (orderData, { getState, rejectWithValue }) => {
    const state = getState();
    const user = selectUser(state); // Récupérer l'utilisateur connecté

    if (!user) {
      return rejectWithValue({ message: "User not authenticated." });
    }

    const token = localStorage.getItem("token"); // Récupérer le token d'authentification

    try {
      const response = await fetch(`${BASE_URL1}add/new/order`, {
        method: "POST",
        headers: getAuthHeaders(state),
        body: JSON.stringify({
          period: orderData.period,  // Période de paiement
          month_1: orderData.month_1, // Montant pour le mois 1
          month_2: orderData.month_2, // Montant pour le mois 2
          month_3: orderData.month_3, // Montant pour le mois 3
          month_4: orderData.month_4, // Montant pour le mois 4
          month_5: orderData.month_5, // Montant pour le mois 5
          month_6: orderData.month_6, // Montant pour le mois 6
          items: orderData.items, // Inclure les items de la commande
          total: orderData.total, // Inclure le total
          user_id: user.id, // Inclure l'ID de l'utilisateur
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      const data = await response.json();
      return data; // Retourner les données de la réponse
    } catch (error) {
      return rejectWithValue({ message: "An error occurred." });
    }
  }
);

// export const fetchOrderProductsAsync = createAsyncThunk(
//   "order/fetchOrderProductsAsync",
//   async (_, { getState, rejectWithValue }) => {
//     const state = getState();
//     const token = localStorage.getItem("token");

//     try {
//       const response = await fetch(`${BASE_URL1}get/new/orderproduct`, {
//         method: 'GET',
//         headers: getAuthHeaders(state),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || 'Failed to fetch orders');
//       }

//       const data = await response.json();


//       const orders = data.orders.map(order => {

//         console.log('Commande:', order);

//         // Gardez le statut tel quel sans modification
//         const groupedProducts = order.products.map(product => ({
//           product_id: product.product_id,
//           quantity: product.quantity,
//           total: product.total,
//           product_name: product.product_name,
//           product_images1: product.product_images1,
//           product_images2: product.product_images2,
//           product_images3: product.product_images3,
//         }));

//         return {
//           order_id: order.order_id,
//           total: order.total,
//           status: order.status,  // Gardez le statut tel quel
//           products: groupedProducts,
//         };
//       });



//       return { orders };  // Retourner directement les commandes

//     } catch (error) {
//       return rejectWithValue({ message: error.message || 'An error occurred' });
//     }
//   }
// );


export const fetchOrderProductsAsync = createAsyncThunk(
  "order/fetchOrderProductsAsync",
  async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${BASE_URL1}get/new/orderproduct`, {
        method: 'GET',
        headers: getAuthHeaders(state),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch orders');
      }

      const data = await response.json();

      // Mettez à jour les commandes et les produits correctement
      const orders = data.orders.map(order => {

        // Récupérez les produits associés à chaque commande
        const groupedProducts = order.products.map(product => ({
          product_id: product.product_id,
          quantity: product.quantity,
          total: product.total,
          product_name: product.product_name,
          product_images1: product.product_images1,
          product_images2: product.product_images2,
          product_images3: product.product_images3,
        }));

        return {
          order_id: order.order_id,
          total: order.total,
          status: order.status,  // Gardez le statut tel quel
          products: groupedProducts,  // Ajouter les produits à chaque commande
        };
      });

      return { orders };  // Retourner directement les commandes

    } catch (error) {
      return rejectWithValue({ message: error.message || 'An error occurred' });
    }
  }
);

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    clearOrder: (state) => {
      state.order = null;
      state.loading = false;
      state.error = null;
      state.orderProducts = []; // Réinitialiser les produits de la commande
      state.status = null; // Réinitialiser le statut
      state.total = null; // Réinitialiser le total
      state.orders = []; // Réinitialiser la liste des commandes
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(placeOrderAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(placeOrderAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.order = action.payload; // Met à jour l'état avec la commande passée
      })
      .addCase(placeOrderAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message; // Gérer les erreurs
      })
      .addCase(fetchOrderProductsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderProductsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload.orders;  // Met à jour les commandes avec leur statut
        state.orderProducts = action.payload.orders.flatMap(order => order.products);  // Met à jour les produits

        // Calculer le total des commandes
        state.total = action.payload.orders.reduce((sum, order) => sum + parseFloat(order.total), 0);
      })
      .addCase(fetchOrderProductsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message; // Gérer les erreurs
      });
  },
});

export const { clearOrder } = orderSlice.actions;

export const selectOrder = (state) => state.order.order;
export const selectOrderLoading = (state) => state.order.loading;
export const selectOrderError = (state) => state.order.error;
export const selectOrderProducts = (state) => state.order.orderProducts; // Sélecteur pour les produits de la commande
export const selectOrders = (state) => state.order.orders; // Sélecteur pour les commandes
export const selectOrderStatus = (state) => state.order.status; // Sélecteur pour le statut

export default orderSlice.reducer;
